import { render, staticRenderFns } from "./designer-detail-table.vue?vue&type=template&id=3190d127&scoped=true"
import script from "./designer-detail-table.vue?vue&type=script&lang=js"
export * from "./designer-detail-table.vue?vue&type=script&lang=js"
import style0 from "./designer-detail-table.vue?vue&type=style&index=0&id=3190d127&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3190d127",
  null
  
)

export default component.exports